module.exports = __webpack_public_path__ + "website/img/successfulDetail_1_4.2712ba46.jpg";